(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/self-exclusion-react/assets/react/components/periods-abtest.js') >= 0) return;  svs.modules.push('/modules/self-exclusion-react/assets/react/components/periods-abtest.js');
'use strict';

const dates = svs.selfExclusion.dates;
const {
  ControlGroup,
  Option,
  Radio
} = svs.ui.ReactForm;
const PeriodsAbTest = _ref => {
  let {
    onHandlePeriod,
    exclusionDates,
    exclusions,
    period,
    isSubmitted
  } = _ref;
  const allGamesExpiry = svs.selfExclusion.useAllExclusions(exclusions);
  const handleChange = periodValue => {
    const foundDate = dates.find(date => date.value === Number(periodValue));
    onHandlePeriod(foundDate);
  };
  return React.createElement(ControlGroup, {
    className: "question-header-text",
    errorMessage: "Du m\xE5ste v\xE4lja en period",
    hasError: isSubmitted && !period,
    v2: true
  }, React.createElement("fieldset", {
    "aria-labelledby": "self-exclusion-header period-selection-label"
  }, React.createElement("legend", {
    className: "question-header-text",
    id: "period-selection-label"
  }, "V\xE4lj hur l\xE5ng pausen ska vara"), React.createElement(Option, null), exclusionDates.map(date => React.createElement("div", {
    className: "padding-bottom-1 question-body-text",
    key: date.id
  }, React.createElement(Radio, {
    checked: (period === null || period === void 0 ? void 0 : period.value) === date.value,
    disabled: date.isExcluded || dateFns.isBefore(date.willExpire, allGamesExpiry),
    key: date.id,
    name: "period",
    onChange: () => handleChange(date.value),
    value: date.value.toString()
  }, date.text)))));
};
svs.selfExclusion.components.PeriodsAbTest = PeriodsAbTest;

 })(window);